import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CFormsDynamiquesComponent } from './c-forms-dynamiques.component';
import { IonicModule } from '@ionic/angular';
import { CFormDynamiqueModule } from '../c-form-dynamique/c-form-dynamique.module';
import { AsInstanceOfFormElementModule } from 'src/app/pipes/as-instance-of-form-element/as-instance-of-form-element.module';
import { MarqueursLegendeModule } from 'src/app/pipes/marqueurs-legende/marqueurs-legende.module';



@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    CFormDynamiqueModule,
    AsInstanceOfFormElementModule,
    MarqueursLegendeModule,
  ],
  declarations: [CFormsDynamiquesComponent],
  exports: [CFormsDynamiquesComponent],
})
export class CFormsDynamiquesModule { }
